import Bloodhound from 'corejs-typeahead';

var $search, $input,
  engines = {
    category: new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace,
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      identify: category => category.id,
      limit: 10,
      remote: {
        url: '/categories?q=%QUERY',
        wildcard: '%QUERY'
      }
    }),
    product: new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace,
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      identify: product => product.id,
      limit: 10,
      remote: {
        url: '/products?q=%QUERY',
        wildcard: '%QUERY'
      }
    }),
  },
  datasets = [
    {
      name: 'categories',
      display: 'name',
      limit: 10,
      source: engines.category,
      templates: {
        notFound: '<div class="tt-empty text-muted">Δε βρέθηκαν κατηγορίες.</div>',
        header (query) {
          const categories = query.suggestions.length === 1 ? 'Κατηγορία' : 'Κατηγορίες';

          return `
              <div class="tt-header">
                  <i class="fa fa-angle-right text-primary"></i> \xa0
                  <strong class="">${query.suggestions.length}</strong>
                  <span class="text-muted">${categories}</span>
              </div>`;
        },
        suggestion (category) {
          return `
              <button type="button">
                  <strong class="text-darker">${category.name}</strong>
                  <span class="text-muted"><br>${category.path}</span>
              </button>`;
        }
      }
    },
    {
      name: 'products',
      display: 'name',
      limit: 10,
      source: engines.product,
      templates: {
        notFound: '<div class="tt-empty text-muted">Δε βρέθηκαν προϊόντα.</div>',
        header (query) {
          const products = query.suggestions.length === 1 ? 'Προϊόν' : 'Προϊόντα';

          return `
              <div class="tt-header">
                  <i class="fa fa-angle-right text-primary"></i> \xa0
                  <strong class="">${query.suggestions.length}</strong>
                  <span class="text-muted">${products}</span>
              </div>`;
        },
        suggestion (product) {
          return `
              <button type="button">
                <div class="media align-items-center">
                  <img src="${product.thumbnail}" alt="${product.name}" width="50" height="50" class="mr-2">
                  <div class="media-body">
                      <strong class="text-darker">${product.name}</strong>
                      <span class="text-muted"><br>${product.category.name}</span>
                  </div>
                </div>
              </button>`;
        },
        footer (search) {
          return `
              <a class="btn btn-primary btn-block text-nowrap" href="/search?q=${search.query}">
                  <i class="fa fa-search mr-2" aria-hidden="true"></i>
                  Δείτε όλα τα αποτελέσματα
              </a>`;
        }
      }
    }
  ];

export function init (options) {
  $search = $(options.selector);
  $input = $search.find('input');

  $input.typeahead({
    debug: true,
    highlight: true,
    hint: true,
    minLength: 3,
  }, datasets);

  _bindEvents(options.events);
}

export function isActive() {
  return $input.typeahead('isActive');
}

// Manually focus
export function focus() {
  $input.trigger('focus');
}

function _bindEvents() {
  $input
    .on('typeahead:select', _redirect)
    .on('typeahead:asyncrequest', _start)
    .on('typeahead:render', _end);
}

function _redirect (e, product) {
  window.location.href = product.url;
}

function _start () {
  $search.find('.fa')
    .removeClass('fa-search')
    .addClass('fa-spin fa-circle-o-notch');
}

function _end () {
  $search.find('.fa')
    .removeClass('fa-spin fa-circle-o-notch')
    .addClass('fa-search');
}
